// Customizable Area Start
import React from "react";
import {
  Box,
  IconButton,
  LinearProgress,
  Modal,
  Snackbar,
  Typography,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import StepName from "./StepName.web";
import StepPhone from "./StepPhone.web";
import StepOtp from "./StepOtp.web";
import StepConfirm from "./StepConfirm.web";
import { CommentOnboardingModalProps } from "./types";

const TOTAL_STEPS = 4;

const STEP_LABELS: Record<number, string> = {
  1: "Your Name",
  2: "Mobile Number",
  3: "Verify Code",
  4: "All Set!",
};

const CommentOnboardingModal: React.FC<CommentOnboardingModalProps> = (props) => {
  const {
    open,
    step,
    onClose,
    onBack,
    firstName,
    lastName,
    phone,
    otp,
    phoneError,
    otpError,
    loading,
    isNewAccount,
  } = props;

  const progress = (step / TOTAL_STEPS) * 100;
  const showBack = step > 1 && step < 4;

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          zIndex: 1400,
        }}
      >
        <Box
          style={{
            background: "#fff",
            width: "100%",
            maxWidth: 480,
            maxHeight: "92vh",
            overflowY: "auto",
            borderRadius: "20px 20px 0 0",
            outline: "none",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {/* Progress bar */}
          <LinearProgress
            variant="determinate"
            value={progress}
            style={{
              borderRadius: "20px 20px 0 0",
              height: 4,
              backgroundColor: "#F1F5F9",
            }}
          />

          {/* Header row */}
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 16px 0",
            }}
          >
            {/* Back button */}
            <Box style={{ width: 36 }}>
              {showBack && (
                <IconButton
                  size="small"
                  onClick={onBack}
                  aria-label="Go back"
                >
                  <ArrowBackIosIcon style={{ fontSize: 18 }} />
                </IconButton>
              )}
            </Box>

            {/* Step indicator */}
            <Typography
              style={{
                fontWeight: 600,
                fontFamily: "Inter",
                fontSize: 13,
                color: "#94A3B8",
              }}
            >
              {STEP_LABELS[step] || ""}
              <span style={{ fontWeight: 400, marginLeft: 6 }}>
                {step}/{TOTAL_STEPS}
              </span>
            </Typography>

            {/* Close button */}
            <IconButton size="small" onClick={onClose} aria-label="Close">
              <CloseIcon style={{ fontSize: 20 }} />
            </IconButton>
          </Box>

          {/* Step content */}
          <Box
            style={{
              padding: "16px 24px 32px",
              paddingBottom: "calc(32px + env(safe-area-inset-bottom, 0px))",
            }}
          >
            {step === 1 && (
              <StepName
                firstName={firstName}
                lastName={lastName}
                onFirstNameChange={props.onFirstNameChange}
                onLastNameChange={props.onLastNameChange}
                onContinue={props.onContinueFromName}
              />
            )}

            {step === 2 && (
              <StepPhone
                phone={phone}
                phoneError={phoneError}
                loading={loading}
                onPhoneChange={props.onPhoneChange}
                onContinue={props.onSendOtp}
                onBack={onBack}
              />
            )}

            {step === 3 && (
              <StepOtp
                otp={otp}
                otpError={otpError}
                loading={loading}
                phone={phone}
                onChange={props.onOtpChange}
                onContinue={props.onVerifyOtp}
                onChangePhone={props.onChangePhone}
                onResendOtp={props.onResendOtp}
              />
            )}

            {step === 4 && (
              <StepConfirm
                isNewAccount={isNewAccount}
                loading={loading}
                onPost={props.onPost}
              />
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CommentOnboardingModal;
// Customizable Area End
